module.exports = __webpack_public_path__ + "media/images/navigation/photos-0134e637a22c63bc5b1ce35bff230f2e.gif";